export default "__VITE_ASSET__924b2a80__"